<ng-template #templateRef>
  <p>
    <mat-form-field appearance="outline" class="shrink">
      <mat-label translate="parameters/quick_replies/details/graph/note/edit-description/label"></mat-label>
      <textarea
        #inputElement
        type="text"
        matInput
        [formControl]="valueCtrl"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
        cdkAutosizeMaxRows="4"
        [maxlength]="noteMaxLength">
      </textarea>
      <mat-icon matSuffix (click)="selectEmoji()">sentiment_satisfied</mat-icon>
      <mat-hint align="end">{{ inputElement.value.length }} / {{ noteMaxLength }}</mat-hint>
    </mat-form-field>
  </p>
</ng-template>

<ng-template #emojiListTemplateRef>
  <app-emojis-list (emojiClicked)="emojiListDialogRef.close($event)"></app-emojis-list>
</ng-template>
